import {Stamp, UserModel, UserPortrait} from '@core/api/data-access';

export type IActiveUserState = {
	id: string;
	user: UserModel;
	portrait: UserPortrait;
	stamps: Stamp[];
};

export const activeUserInitialState: IActiveUserState = {
	user: null,
	id: '',
	portrait: null,
	stamps: null,
};
